import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { browserClient } from './client/browser';

export interface RandomQuote {
    id: string;
    kind: string;
    text: string;
    has_greeting: boolean;
    attribution: string | null;
}

function getConfig<T>(
    configOverrides: AxiosRequestConfig<T> = { headers: {} }
) {
    return {
        ...configOverrides,
    };
}

export function createRandomQuotesApi(
    // We can change this if we want to instead create an API for the server using a server client
    client: AxiosInstance = browserClient
) {
    return {
        getCalmRandomQuotes: async (configOverrides?: AxiosRequestConfig) => {
            const path = process.env.NEXT_PUBLIC_QUOTES_URL;
            return client.get<RandomQuote[]>(
                `${path}`,
                getConfig(configOverrides)
            );
        },
    };
}
